import {Directive, ElementRef, input, OnDestroy, OnInit} from '@angular/core';
import {ScrollManagerService} from '@core/service/scroll-manager.service';

@Directive({
  selector: '[appScrollTarget]'
})
export class ScrollTargetDirective implements OnInit, OnDestroy {

  public readonly appScrollTarget = input.required<string>();

  constructor(
    private readonly host: ElementRef<HTMLElement>,
    private readonly scrollManager: ScrollManagerService
  ) {}

  public ngOnInit() {
    this.scrollManager.register(this);
  }

  public ngOnDestroy() {
    this.scrollManager.remove(this);
  }

  scroll() {
    setTimeout(() => {
      this.host.nativeElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    });
  }

}
